import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";

export const deleteQuote = (id_quote: number) => {
   return apiClient<ApiResponse>(`/v1/quote/${id_quote}`, {
      method: "DELETE"
   })
}
